module.exports = __webpack_public_path__ + "img/about-values-courage.jpg?e9e8b08974e3001941b6424b33c7d341";